export default "__VITE_ASSET__BopN0z$N__"